import { render, staticRenderFns } from "./history-item.vue?vue&type=template&id=a40a5d62&scoped=true"
import script from "./history-item.vue?vue&type=script&lang=js"
export * from "./history-item.vue?vue&type=script&lang=js"
import style0 from "./history-item.vue?vue&type=style&index=0&id=a40a5d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40a5d62",
  null
  
)

export default component.exports